<template>
  <div class="container">

    <button type="button" name="newPost" @click='createPost'>
      Add New Post
    </button>

    <vue-good-table
      :columns="columns"
      :rows="posts"
      :search-options="{
        enabled: true
      }"
      >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'actions'">
          <button name="edit" @click="editPost(props.row.id)">🖊️</button>
          <button name="delete" @click="deletePost(props.row.id)">❌️</button>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </div>

</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import { mapGetters } from 'vuex'


export default {
  name: 'admin',
  data() {
    return {
      columns: [
        {
          label: 'SKU',
          field: 'sku'
        },
        {
          label: 'Title',
          field: 'title',
        },
        {
          label: 'Artist',
          field: 'artist',
        },
        {
          label: 'Location',
          field: 'location',
        },
        // {
        //   label: 'Status',
        //   field: 'status',
        //   filterOptions: {
      	//      enabled: true,
        //      filterDropdownItems : [ 'draft', 'published']
        //   }
        // },
        // {
        //   label: 'Created On',
        //   field: 'createdAt',
        //   type: 'date',
        //   dateInputFormat: 'yyyy-MM-dd',
        //   dateOutputFormat: 'ccc MMM co yyyy'
        // },
        // {
        //   label: 'Modified On',
        //   field: 'modifiedAt',
        //   type: 'date',
        //   dateInputFormat: 'yyyy-MM-dd',
        //   dateOutputFormat: 'ccc MMM co yyyy',
        // },
        {
          label: 'Actions',
          field: 'actions'
        }
      ],
    }
  },
  mounted () {
    this.$store.dispatch('getPosts')
  },
  methods: {
    createPost(postId) {
      this.$router.push('add')
    },
    editPost(postId) {
      this.$router.push({
        path: 'artworks/edit',
        name: 'Edit',
        params: { postId }
      })
    },
    deletePost(postId) {
      this.$modal.show('dialog', {
        title: 'Are you sure ?',
        text: `You are about to delete a post.`,
        buttons: [
          {
            title: 'Delete',
            handler: () => {
              this.$store.dispatch('deletePost', { postId })
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Close'
          }
       ]
      })
    }
  },
  computed: mapGetters([
    'posts'
  ]),
  components: {
    VueGoodTable,
  }
}
</script>

<style scoped media="screen">
  button[name="delete"] {
    background: white
  }

  button[name="edit"] {
    background: white
  }
</style>
